import {
  FileModel, ShippingAddressModel, BillingAddressModel,
  PartnerShopModel, PartnerProductModel, PartnerProductUnitModel,
  PartnerProductSubscriptionModel, PartnerShippingFrontendModel,
  CustomerModel, UserModel,
} from '.';
import { unescape } from 'html-escaper';
import { translate } from '../helpers/frontend';

/*
  type : String
    - C2U
    - Store

  subscriptionType : Number
    2 = Coupon Subscription
    Else = Product Subscription

  status : Number
    -1 = Charge Failed
    0  = Cancel
    1  = On Hold
    2  = In Process
    3  = Completed
*/

export class CustomerSubscriptionModel {
  constructor(data={}) {
    this._id = data?._id || null;

    this.type = data.type? unescape(data.type): 'C2U';
    this.channel = data.channel? unescape(data.channel): '2C2P';
    
    this.prefixOrderId2C2P = data.prefixOrderId2C2P? unescape(data.prefixOrderId2C2P): null;
    try { this.payload2C2P = data.payload2C2P? JSON.parse(unescape(data.payload2C2P)): {}; } catch {}
    
    this.customer = new CustomerModel(data.customer || {});

    this.subscriptionType = Number(data.subscriptionType || 1);
    this.subscription = new PartnerProductSubscriptionModel(data.subscription || {});

    this.name = data.name? unescape(data.name): '';
    this.description = data.description? unescape(data.description): '';
    this.content = data.content? unescape(data.content): '';
    this.agreement = data.agreement? unescape(data.agreement): '';

    this.shop = new PartnerShopModel(data.shop || {});
    this.partner = new UserModel(data.partner || {});
    this.salesManager = new UserModel(data.salesManager || {});

    this.recurringType = Number(data.recurringType || 2);
    this.recurringInterval = Number(data.recurringInterval || 1);
    this.recurringCount = Number(data.recurringCount || 12);

    this.hasRelatedProducts = Number(data.hasRelatedProducts || 0);
    this.relatedCredit = Number(data.relatedCredit || 0);
    this.relatedProducts = (data.relatedProducts || []).map(d => this.relatedProduct(d));

    this.hasFreeProducts = Number(data.hasFreeProducts || 0);
    this.freeCredit = Number(data.freeCredit || 0);
    this.freeProducts = (data.freeProducts || []).map(d => this.freeProduct(d));

    this.hasGiveawayProducts = Number(data.hasGiveawayProducts || 0);
    this.giveawayProducts = (data.giveawayProducts || []).map(d => this.giveawayProduct(d));

    this.selectionSteps = (data.selectionSteps || []).map(d => this.selectionStep(d));
    
    this.freeShippingCost = Number(data.freeShippingCost || 1);
    this.signature = data.signature 
      ? data.signature.indexOf('data:image') === 0 
        ? unescape(data.signature) 
        : unescape(`data:image/jpg;base64,${data.signature}`) 
      : '';

    this.shippingAddress = new ShippingAddressModel(data.shippingAddress || {});
    this.billingAddress = new BillingAddressModel(data.billingAddress || {});

    this.discount = data.discount || data.discount===0? Number(data.discount): null;
    this.subtotal = data.subtotal || data.subtotal===0? Number(data.subtotal): null;
        
    this.vatName = data.vatName? unescape(data.vatName): '';
    this.vat = data.vat || data.vat===0? Number(data.vat): null;
    this.vatPercent = data.vatPercent || data.vatPercent===0? Number(data.vatPercent): null;

    this.total = data.total || data.total===0? Number(data.total): null;
    this.initialPriceInVAT = data.initialPriceInVAT || data.initialPriceInVAT===0 
      ? Number(data.initialPriceInVAT): null;
    this.packageDiscountInVAT = data.packageDiscountInVAT || data.packageDiscountInVAT===0
      ? Number(data.packageDiscountInVAT): null;
    this.cashDiscount = data.cashDiscount || data.cashDiscount===0? Number(data.cashDiscount): null;

    this.shippingFrontend = new PartnerShippingFrontendModel(data.shippingFrontend || {});
    this.shippingCost = data.shippingCost || data.shippingCost===0? Number(data.shippingCost): null;

    this.grandTotal = data.grandTotal || data.grandTotal===0? Number(data.grandTotal): null;

    this.status = data.status ?? 0;

    this.recurringDates = data.recurringDates || [];
    this.nextRecurringDate = data.nextRecurringDate || null;
    this.startAt = data.startAt || null;
    this.endAt = data.endAt || null;

    this.createdAt = data.createdAt || null;
    this.updatedAt = data.updatedAt || null;
  }

  isValid(){ return this._id? true: false; }

  relatedProduct(d={}){
    return {
      _id: d._id || null,
      product: new PartnerProductModel(d.product || {}),
      productId: d.product?._id,
      unit: new PartnerProductUnitModel(d.unit || {}),
      unitId: d.unit?._id,
      credit: d.credit ?? 1,
      addPriceInVAT: d.addPriceInVAT ?? 0,
      inCart: d.inCart ?? 0,
    };
  }
  freeProduct(d={}){
    return {
      _id: d._id || null,
      product: new PartnerProductModel(d.product || {}),
      productId: d.product?._id,
      unit: new PartnerProductUnitModel(d.unit || {}),
      unitId: d.unit?._id,
      credit: d.credit ?? 1,
      inCart: d.inCart ?? 0,
    };
  }
  giveawayProduct(d={}){
    return {
      _id: d._id || null,
      product: new PartnerProductModel(d.product || {}),
      productId: d.product?._id,
      unit: new PartnerProductUnitModel(d.unit || {}),
      unitId: d.unit?._id,
      inCart: d.inCart ?? 0,
    };
  }

  selectionStep(d={}){
    return {
      _id: d._id || null,
      step: d.step || null,
      name: d.name? unescape(d.name): null,
      icon: new FileModel(d.icon || {}),
      credit: d.credit ?? 1,
      order: d.order || 1,
      products: d.products?.length? d.products.map(k => {
        return {
          product: new PartnerProductModel(k.product || {}),
          productId: k.product?._id,
          unit: new PartnerProductUnitModel(k.unit || {}),
          unitId: k.unit?._id,
          credit: k.credit ?? 1,
          inCart: k.inCart ?? 0,
        };
      }): [],
    };
  }

  displaySubscriptionType(langObj={}){
    if(!this.isValid()) return (<></>);
    if(this.subscriptionType===2) return (<span className="ss-tag bg-info">{translate('Coupon Subscription', langObj)}</span>);
    return (<span className="ss-tag bg-success">{translate('Product Subscription', langObj)}</span>);
  }
  
  displayStatus(langObj={}){
    if(!this.isValid()) return (<></>);
    if(this.status === -1) return (<span className="ss-tag bg-danger">{translate('Charge Failed', langObj)}</span>);
    if(this.status === 0) return (<span className="ss-tag bg-gray">{translate('Cancel', langObj)}</span>);
    if(this.status === 1) return (<span className="ss-tag bg-warning">{translate('On Hold', langObj)}</span>);
    if(this.status === 2) return (<span className="ss-tag bg-info">{translate('In Process', langObj)}</span>);
    if(this.status === 3) return (<span className="ss-tag bg-success">{translate('Completed', langObj)}</span>);
    return (<></>);
  }
  displayFrequency(langObj={}){
    if(!this.isValid()) return '';
    let _text = '';
    if(this.recurringType === 1){
      if(this.recurringInterval === 1) _text += translate('Per Day', langObj);
      else _text += translate('Per _X_ Days', langObj, { '_X_': this.recurringInterval });
    }else if(this.recurringType === 2){
      if(this.recurringInterval === 1) _text += translate('Per Month', langObj);
      else _text += translate('Per _X_ Months', langObj, { '_X_': this.recurringInterval });
    }else if(this.recurringType === 3){
      if(this.recurringInterval === 1) _text += translate('Per Year', langObj);
      else _text += translate('Per _X_ Years', langObj, { '_X_': this.recurringInterval });
    }
    if(this.recurringCount === 1) _text += ` ${translate('For 1 Time', langObj)}`;
    else _text += ` ${translate('For _X_ Times', langObj, { '_X_': this.recurringCount })}`;
    return _text;
  }
  displayFreeShippingCost(langObj={}) {
    if(this.isValid()){
      if(this.freeShippingCost === 1) return (<span className="ss-tag bg-success">{translate('Yes', langObj)}</span>);
      else return (<span className="ss-tag bg-warning">{translate('No', langObj)}</span>);
    }else{
      return (<span className="ss-tag bg-warning">{translate('No', langObj)}</span>);
    }
  }
}